var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7257 8.21473C14.5334 12.2207 11.103 15.458 7.23306 15.2846C3.2183 15.1047 -0.016783 11.6619 0.143398 7.77368C0.307967 3.76843 3.74931 0.550183 7.67411 0.714752C11.6845 0.882247 14.9115 4.35064 14.7257 8.21546V8.21473ZM7.45175 2.16881C4.27959 2.15857 1.61502 4.81363 1.61136 7.98799C1.6077 11.1485 4.24227 13.8006 7.40493 13.8211C10.5749 13.8415 13.249 11.1923 13.2621 8.01798C13.2753 4.84362 10.6283 2.17905 7.45175 2.16881Z",
    fill: "#3D4A50",
    stroke: "#3D4A50",
    strokeWidth: 0.0467762,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12041 9.69012C9.45248 10.0302 9.76991 10.3557 10.0881 10.6819C9.2762 11.8617 6.56995 11.9524 5.16343 10.8392C3.52944 9.5453 3.33194 7.10309 4.73554 5.55541C6.07916 4.07428 8.79931 3.93239 10.0661 5.24602C9.73334 5.57954 9.40054 5.9138 9.0575 6.25757C7.86821 5.54078 6.55166 5.66805 5.76172 6.61012C5.06541 7.43955 5.0815 8.60835 5.80049 9.42389C6.59847 10.3287 7.91796 10.4413 9.11968 9.69085L9.12041 9.69012Z",
    fill: "#3D4A50",
    stroke: "#3D4A50",
    strokeWidth: 0.0467762,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcon);
export default __webpack_public_path__ + "static/media/c-icon.01a20a14e0e7ba34683c214b968f49be.svg";
export { ForwardRef as ReactComponent };